import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getSellerSettings() {
    return axios.get(`${API_URL}/pos/seller-settings`, { headers: authHeader() });
  },
  getProducts(params) {
    const query = new URLSearchParams(params).toString();
    return axios.get(`${API_URL}/pos/products?${query}`, { headers: authHeader() });
  },
  getProductionVariations(inventoryId) {
    return axios.get(`${API_URL}/pos/products/${inventoryId}/production-variations`, {
      headers: authHeader(),
    });
  },
  getClients() {
    return axios.get(`${API_URL}/pos/clients`, { headers: authHeader() });
  },
  createClient(data) {
    return axios.post(`${API_URL}/pos/clients`, data, { headers: authHeader() });
  },
  getCashSession() {
    return axios.get(`${API_URL}/pos/cash-session`, { headers: authHeader() });
  },
  openCashSession() {
    return axios.post(`${API_URL}/pos/cash-session/open`, {}, { headers: authHeader() });
  },
  closeCashSession() {
    return axios.post(`${API_URL}/pos/cash-session/close`, {}, { headers: authHeader() });
  },
  createSale(data) {
    return axios.post(`${API_URL}/pos/sales`, data, { headers: authHeader() });
  },
};
